import React from 'react'
import { Grid, Row } from 'react-bootstrap'
import { AmbassadorSection } from '../../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from '../../../../../../../Components/Section/SectionTitle'
import { ButtonWithLabel } from '../../../../../../../Components/Buttons/ButtonWithLabel'
import Checked from '../../../../../../../Assets/Images/icons/checked'

const SettingsSectionView = ({ onSave, loading, disabled, children }) => {
  return (
    <AmbassadorSection className="settings">
      <Grid fluid>
        <Row>
          <SectionTitle>Settings</SectionTitle>
        </Row>
        <Row>{children}</Row>
        <Row style={{ marginTop: '2rem' }}>
          <ButtonWithLabel
            label={loading ? 'Saving...' : 'Save'}
            icon={<Checked />}
            onClickHandler={onSave}
            key="saveUserSettings"
            disabled={disabled}
            cypress_id={'saveUserSettingsBtn'}
          />
        </Row>
      </Grid>
    </AmbassadorSection>
  )
}

export default SettingsSectionView
